import React from "react";
import { getDateTime } from "../../helpers/dateTime";
import CustomPriceDisplay from "../../commons/CustomPriceDisplay";
import { BsBoxSeam } from "react-icons/bs";
import { TbTruckDelivery, TbDiscount2 } from "react-icons/tb";

function AccountOrdersItem({
  orderGroup,
  onViewClick,
  buttonText = "View Details",
  setSelectedItem,
}) {
  const firstOrder = orderGroup.orders[0];
  const otherItems = orderGroup.orders.slice(1, 4); // Show max 3 additional items
  const remainingItems = orderGroup.orders.length > 4 ? orderGroup.orders.length - 4 : 0;
  
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return 'text-green-600';
      case 'pending':
        return 'text-yellow-600';
      case 'cancelled':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-all mb-6">
      {/* Order Header */}
      <div className="flex flex-wrap justify-between items-center mb-4 pb-3 border-b">
        <div className="flex items-center gap-2">
          <BsBoxSeam className="text-xl text-[#FF9D21]" />
          <span className="text-[14px] font-semibold">Order #{orderGroup.orderNumber}</span>
          {orderGroup?.couponCode && (
            <div className="flex items-center gap-1 text-green-600 bg-green-50 px-2 py-1 rounded-full">
              <TbDiscount2 className="text-sm" />
              <span className="text-[12px]">{orderGroup.couponCode}</span>
            </div>
          )}
        </div>
        <div className={`flex items-center gap-2 ${getStatusColor(orderGroup.status)}`}>
          <TbTruckDelivery className="text-xl" />
          <span className="capitalize text-[14px]">{orderGroup.status}</span>
        </div>
      </div>

      {/* Order Items Grid */}
      <div className="grid grid-cols-4 max-md:grid-cols-2 gap-4 mb-4">
        {/* Main Item */}
        <div className="col-span-1">
          <div className="relative">
            <img
              src={firstOrder?.Product?.imageOne}
              className="w-full aspect-square object-cover rounded-lg"
              alt=""
              loading="lazy"
            />
            <div className="absolute top-2 left-2 bg-white px-2 py-1 rounded-full text-[12px]">
              ×{firstOrder.quantity}
            </div>
          </div>
        </div>

        {/* Other Items */}
        {otherItems.map((item) => (
          <div key={item.id} className="col-span-1">
            <div className="relative">
              <img
                src={item?.Product?.imageOne}
                className="w-full aspect-square object-cover rounded-lg"
                alt=""
                loading="lazy"
              />
              <div className="absolute top-2 left-2 bg-white px-2 py-1 rounded-full text-[12px]">
                ×{item.quantity}
              </div>
            </div>
          </div>
        ))}

        {/* Remaining Items Count */}
        {remainingItems > 0 && (
          <div className="col-span-1">
            <div className="relative bg-gray-100 w-full aspect-square rounded-lg flex items-center justify-center">
              <span className="text-gray-600 font-medium">+{remainingItems} more</span>
            </div>
          </div>
        )}
      </div>

      {/* Order Footer */}
      <div className="flex justify-between items-center pt-3 border-t">
        <div className="flex flex-col gap-1">
          <p className="text-[14px] text-gray-600">
            Ordered on {getDateTime(orderGroup.createdAt)}
          </p>
          <div className="flex flex-col">
            <p className="text-[16px] font-semibold">
              Total: <CustomPriceDisplay price={orderGroup.totalAmount} />
            </p>
            {orderGroup?.couponDiscount && (
              <p className="text-[12px] text-green-600">
                Saved: ₦{orderGroup.couponDiscount}
              </p>
            )}
          </div>
        </div>
        <button
          className="bg-[#FF9D21] bg-opacity-10 text-[#FF9D21] hover:bg-opacity-100 hover:text-white transition-all py-2 px-4 rounded-full text-[14px]"
          onClick={() => {
            if (setSelectedItem) {
              setSelectedItem(orderGroup);
            }
          }}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default AccountOrdersItem;
